<template>
    <div class="o-container o-container--thin registration-page" :class="{'eoi-form-top-gap': $route.name === 'thank-you'}">
      <form
          :class="[
        'styled-form',
        'styled-form--white-box',
      ]"
          autocomplete="off"
      >
        <div class="o-grid--no-hgutter">
          <div class="o-grid--no-hgutter o-grid__item">
            <h1 class="common__heading m-auto">
              Thank you
            </h1>
          </div>
        </div>
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              Thank you for registering interest in playing football in 2023! We’ll be in contact with all the necessary information over the coming weeks.
            </div>
          </div>
        </div>
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              Can’t wait and want to play football now? Each State Federation facilitates a variety of programs and competitions outside of the traditional season. Find out more at <a target="_blank" href="https://www.playfootball.com.au/play-football-now-your-region" >https://www.playfootball.com.au/play-football-now-your-region</a>
            </div>
          </div>
        </div>
        <div class="o-grid--no-hgutter">
          <div class="o-grid__item">
            <div class="fanoffer-preferences-view__item m-auto">
              In the meantime, do you want access to pre-sale tickets, the latest news, exclusive content and special offers and discounts?
              Well, we’ve got you covered. <a href="/" >Sign up</a> for a Football Account today!
            </div>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
	import EoiForm from '../forms/EoiForm.vue';

	export default {
    components: {
      EoiForm
    }
  };
</script>

<style lang="scss" scoped>

</style>
